import React, { useEffect, useState } from "react";
import { TextField, Button, Skeleton, CircularProgress, Typography } from "@mui/material";
import { toast } from "react-toastify";

import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { ApiService } from "../../ApiService";

import jimbo_store from "../../../images/jhimbo-store.png";
import { returnFullURL } from "../../../utils/goblaFunctions";

function parseTextWithAsterisks(text) {
	const lines = text.split("\n");
	return lines.map((line, index) => {
		const regex = /\*([^*]+)\*/g;
		let match;
		let lastIndex = 0;
		let key = 0;
		const elements = [];
		while ((match = regex.exec(line)) !== null) {
			if (match.index > lastIndex) {
				elements.push(<span key={`before-${key}`}>{line.slice(lastIndex, match.index)}</span>);
				key++;
			}
			elements.push(
				<span key={`match-${key}`} style={{ color: "var(--theme-company)" }}>
					{match[1]}
				</span>
			);
			key++;
			lastIndex = match.index + match[0].length;
		}
		if (lastIndex < line.length) {
			elements.push(<span key={`after-${key}`}>{line.slice(lastIndex)}</span>);
		}
		return (
			<div key={`line-${index}`} style={{ whiteSpace: "pre-wrap" }}>
				{elements}
			</div>
		);
	});
}

export const VisitasHistoriaEdit = ({ companyData, currentBranch }) => {
	// Image states
	const [imgHistoria, setImgHistoria] = useState(jimbo_store);
	const [imgActualidad, setImgActualidad] = useState(jimbo_store);
	const [modalOpen, setModalOpen] = useState(false);
	const [previewImg, setPreviewImg] = useState(null);
	const [editTarget, setEditTarget] = useState(null);
	const [selectedFile, setSelectedFile] = useState(null);
	const apiUrl = process.env.REACT_APP_API_URL;
	// Loading states
	const [isLoading, setIsLoading] = useState(false);
	const [isDataLoading, setIsDataLoading] = useState(true);

	// View3 Data States (Historia)
	const [companyDetails, setCompanyDetails] = useState({});
	const [historiaTitle, setHistoriaTitle] = useState("");
	const [historiaTitleOriginal, setHistoriaTitleOriginal] = useState("");
	const [editingHistoriaTitle, setEditingHistoriaTitle] = useState(false);

	const [historiaDescription, setHistoriaDescription] = useState("");
	const [historiaDescriptionOriginal, setHistoriaDescriptionOriginal] = useState("");
	const [editingHistoriaDescription, setEditingHistoriaDescription] = useState(false);

	// View4 Data States (Actualidad)
	const [actualidadTitle, setActualidadTitle] = useState("");
	const [actualidadTitleOriginal, setActualidadTitleOriginal] = useState("");
	const [editingActualidadTitle, setEditingActualidadTitle] = useState(false);

	const [actualidadDescription, setActualidadDescription] = useState("");
	const [actualidadDescriptionOriginal, setActualidadDescriptionOriginal] = useState(actualidadDescription);
	const [editingActualidadDescription, setEditingActualidadDescription] = useState(false);

	useEffect(() => {
		if (companyData) {
			setCompanyDetails(companyData);
			// Set historia values if available
			if (companyData.view3?.title) {
				setHistoriaTitle(companyData.view3.title);
				setHistoriaTitleOriginal(companyData.view3.title);
			}
			if (companyData.view3?.text) {
				setHistoriaDescription(companyData.view3.text);
				setHistoriaDescriptionOriginal(companyData.view3.text);
			}
			// Set actualidad values if available
			if (companyData.view4?.title) {
				setActualidadTitle(companyData.view4.title);
				setActualidadTitleOriginal(companyData.view4.title);
			}
			if (companyData.view4?.text) {
				setActualidadDescription(companyData.view4.text);
				setActualidadDescriptionOriginal(companyData.view4.text);
			}
			setIsDataLoading(false);
		}
	}, [companyData]);

	// Modal handling functions
	const handleOpenModal = (target) => {
		setEditTarget(target);
		setModalOpen(true);
	};

	const handleCloseModal = () => {
		setModalOpen(false);
		setPreviewImg(null);
		setSelectedFile(null);
	};

	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			setSelectedFile(file);
			setPreviewImg(URL.createObjectURL(file));
		}
	};

	const handleAccept = async () => {
		if (!selectedFile || !currentBranch) return;
		setIsLoading(true);
		try {
			const formData = new FormData();
			formData.append("file", selectedFile);
			const uploadResponse = await ApiService.fetchData(
				"api/upload/file",
				{ method: "POST", body: formData },
				false
			);
			if (uploadResponse?.url) {
				// Step 2: Update company data with new image URL
				const viewToUpdate = editTarget === "historia" ? "view3" : "view4";
				const updatedData = {
					[viewToUpdate]: {
						img_url: uploadResponse.url,
					},
				};
				const url = `api/company/update/us?key_branch=${currentBranch}`;
				const response = await ApiService.fetchData(url, {
					method: "PUT",
					body: JSON.stringify(updatedData),
				});

				if (response?.code === 200) {
					const imageUrl = `api/company/us?key_branch=${currentBranch}`;
					const imageResponse = await ApiService.fetchData(imageUrl);
					if (editTarget === "historia" && imageResponse?.view3?.img_url) {
						setCompanyDetails((prev) => ({
							...prev,
							view3: {
								...prev.view3,
								img_url: imageResponse.view3.img_url,
							},
						}));
					} else if (editTarget === "actualidad" && imageResponse?.view4?.img_url) {
						setCompanyDetails((prev) => ({
							...prev,
							view4: {
								...prev.view4,
								img_url: imageResponse.view4.img_url,
							},
						}));
					}
					setModalOpen(false);
					toast.success("Imagen actualizada correctamente");
				} else {
					toast.error(response?.message || "Error al actualizar la imagen");
				}
			} else {
				toast.error("Error al subir la imagen al servidor");
			}
		} catch (error) {
			toast.error("Ocurrió un error al procesar la imagen");
		} finally {
			setIsLoading(false);
			setSelectedFile(null);
			setPreviewImg(null);
		}
	};
	const handleRemovePreview = () => {
		setPreviewImg(null);
		setSelectedFile(null);
	};
	const handleHistoriaTitleChange = (e) => {
		if (e.target.value.length <= 70) {
			setHistoriaTitle(e.target.value);
		}
	};
	const activateHistoriaTitleEdit = () => {
		setEditingHistoriaTitle(true);
		setEditingHistoriaDescription(false);
		setEditingActualidadTitle(false);
		setEditingActualidadDescription(false);
	};
	const cancelHistoriaTitleEdit = () => {
		setHistoriaTitle(historiaTitleOriginal);
		setEditingHistoriaTitle(false);
	};
	const saveHistoriaTitle = async () => {
		if (!currentBranch) return;
		setIsLoading(true);
		const updatedData = {
			view3: {
				title: historiaTitle,
			},
		};
		try {
			const url = `api/company/update/us?key_branch=${currentBranch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify(updatedData),
			};

			const response = await ApiService.fetchData(url, payload);

			if (response?.code === 200) {
				// Update local state with new value
				setHistoriaTitleOriginal(historiaTitle);
				setCompanyDetails((prev) => ({
					...prev,
					view3: {
						...prev.view3,
						title: historiaTitle,
					},
				}));
				setEditingHistoriaTitle(false);
				toast.success(response.message || "Título de historia actualizado correctamente");
			} else {
				toast.error(response?.message || "Error al actualizar el título de historia");
			}
		} catch (error) {
			toast.error("Ocurrió un error al guardar el título de historia");
		} finally {
			setIsLoading(false);
		}
	};
	const handleHistoriaDescriptionChange = (e) => {
		if (e.target.value.length <= 550) {
			setHistoriaDescription(e.target.value);
		}
	};
	const activateHistoriaDescriptionEdit = () => {
		setEditingHistoriaDescription(true);
		setEditingHistoriaTitle(false);
		setEditingActualidadTitle(false);
		setEditingActualidadDescription(false);
	};
	const cancelHistoriaDescriptionEdit = () => {
		setHistoriaDescription(historiaDescriptionOriginal);
		setEditingHistoriaDescription(false);
	};

	const saveHistoriaDescription = async () => {
		if (!currentBranch) return;
		setIsLoading(true);

		const updatedData = {
			view3: {
				text: historiaDescription,
			},
		};

		try {
			const url = `api/company/update/us?key_branch=${currentBranch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify(updatedData),
			};
			const response = await ApiService.fetchData(url, payload);
			if (response?.code === 200) {
				setHistoriaDescriptionOriginal(historiaDescription);
				setCompanyDetails((prev) => ({
					...prev,
					view3: {
						...prev.view3,
						text: historiaDescription,
					},
				}));
				setEditingHistoriaDescription(false);
				toast.success(response.message || "Descripción de historia actualizada correctamente");
			} else {
				toast.error(response?.message || "Error al actualizar la descripción de historia");
			}
		} catch (error) {
			toast.error("Ocurrió un error al guardar la descripción de historia");
		} finally {
			setIsLoading(false);
		}
	};

	// Actualidad title handlers
	const handleActualidadTitleChange = (e) => {
		if (e.target.value.length <= 70) {
			setActualidadTitle(e.target.value);
		}
	};

	const activateActualidadTitleEdit = () => {
		setEditingActualidadTitle(true);
		setEditingHistoriaTitle(false);
		setEditingHistoriaDescription(false);
		setEditingActualidadDescription(false);
	};

	const cancelActualidadTitleEdit = () => {
		setActualidadTitle(actualidadTitleOriginal);
		setEditingActualidadTitle(false);
	};

	const saveActualidadTitle = async () => {
		if (!currentBranch) return;
		setIsLoading(true);

		const updatedData = {
			view4: {
				title: actualidadTitle,
			},
		};

		try {
			const url = `api/company/update/us?key_branch=${currentBranch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify(updatedData),
			};

			const response = await ApiService.fetchData(url, payload);

			if (response?.code === 200) {
				// Update local state with new value
				setActualidadTitleOriginal(actualidadTitle);
				setCompanyDetails((prev) => ({
					...prev,
					view4: {
						...prev.view4,
						title: actualidadTitle,
					},
				}));
				setEditingActualidadTitle(false);
				toast.success(response.message || "Título de actualidad actualizado correctamente");
			} else {
				toast.error(response?.message || "Error al actualizar el título de actualidad");
			}
		} catch (error) {
			toast.error("Ocurrió un error al guardar el título de actualidad");
		} finally {
			setIsLoading(false);
		}
	};

	// Actualidad description handlers
	const handleActualidadDescriptionChange = (e) => {
		if (e.target.value.length <= 550) {
			setActualidadDescription(e.target.value);
		}
	};
	const activateActualidadDescriptionEdit = () => {
		setEditingActualidadDescription(true);
		setEditingHistoriaTitle(false);
		setEditingHistoriaDescription(false);
		setEditingActualidadTitle(false);
	};

	const cancelActualidadDescriptionEdit = () => {
		setActualidadDescription(actualidadDescriptionOriginal);
		setEditingActualidadDescription(false);
	};

	const saveActualidadDescription = async () => {
		if (!currentBranch) return;
		setIsLoading(true);

		const updatedData = {
			view4: {
				text: actualidadDescription,
			},
		};

		try {
			const url = `api/company/update/us?key_branch=${currentBranch}`;
			const payload = {
				method: "PUT",
				body: JSON.stringify(updatedData),
			};

			const response = await ApiService.fetchData(url, payload);

			if (response?.code === 200) {
				// Update local state with new value
				setActualidadDescriptionOriginal(actualidadDescription);
				setCompanyDetails((prev) => ({
					...prev,
					view4: {
						...prev.view4,
						text: actualidadDescription,
					},
				}));
				setEditingActualidadDescription(false);
				toast.success(response.message || "Descripción de actualidad actualizada correctamente");
			} else {
				toast.error(response?.message || "Error al actualizar la descripción de actualidad");
			}
		} catch (error) {
			toast.error("Ocurrió un error al guardar la descripción de actualidad");
		} finally {
			setIsLoading(false);
		}
	};

	return (
		<div>
			{/* PRIMER BLOQUE: "Nuestra Historia / Corporacion / Maquinarias / Jhimbo" */}
			<div className="historia-section">
				<div className="dots-1"></div>
				<div className="doughnut-1"></div>
				<div className="doughnut-2"></div>
				<div className="historia-content">
					<div style={{ backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 0, width: '100%', height: '100%', position: 'absolute', top: '0px', left: '0px' }}></div>

					{/* Original text content - will be hidden on mobile */}
					<div className="text-content" style={{ zIndex: 1 }}>
						{isDataLoading ? (
							<>
								<Skeleton variant="text" width="70%" height={60} />
								<Skeleton variant="text" width="100%" height={25} />
								<Skeleton variant="text" width="95%" height={25} />
								<Skeleton variant="text" width="90%" height={25} />
							</>
						) : (
							<>
								<div className="title-stack">
									{/* Título de Historia */}
									{editingHistoriaTitle ? (
										<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
											<p style={{ fontSize: "14px", color: "#ccc", marginBottom: "4px" }}>
												Coloca entre * para poner texto en azul Ej: *Historia*
											</p>
											<TextField
												multiline
												minRows={3}
												variant="outlined"
												size="small"
												value={historiaTitle}
												onChange={handleHistoriaTitleChange}
												sx={{
													"& .MuiInputBase-input": {
														textAlign: "left",
														color: "#fff",
														fontSize: "30px",
														fontWeight: 800,
														lineHeight: "1.5",
													},
												}}
											/>
											<Typography
												variant="caption"
												sx={{
													display: "block",
													textAlign: "right",
													color:
														historiaTitle.length >= 60
															? historiaTitle.length >= 70
																? "error.main"
																: "warning.main"
															: "text.secondary",
													mt: 0.5,
													mb: 1,
												}}>
												{historiaTitle.length}/70 caracteres
											</Typography>
											<div>
												<Button
													variant="contained"
													color="primary"
													onClick={saveHistoriaTitle}
													disabled={isLoading}>
													{isLoading ? <CircularProgress size={20} /> : "Guardar"}
												</Button>
												<Button
													variant="outlined"
													onClick={cancelHistoriaTitleEdit}
													disabled={isLoading}
													sx={{ backgroundColor: "#fff", marginLeft: 2 }}>
													Cancelar
												</Button>
											</div>
										</div>
									) : (
										<h1
											className="historia-title"
											style={{ cursor: "pointer" }}
											onClick={activateHistoriaTitleEdit}>
											{parseTextWithAsterisks(historiaTitle)}
										</h1>
									)}
								</div>

								{/* Descripción de Historia */}
								{editingHistoriaDescription ? (
									<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
										<TextField
											variant="outlined"
											multiline
											minRows={4}
											value={historiaDescription}
											onChange={handleHistoriaDescriptionChange}
											sx={{
												"width": "100%",
												"& textarea": { textAlign: "left", color: "#fff" },
											}}
										/>
										<Typography
											variant="caption"
											sx={{
												display: "block",
												textAlign: "right",
												color:
													historiaDescription.length >= 500
														? historiaDescription.length >= 550
															? "error.main"
															: "warning.main"
														: "text.secondary",
												mt: 0.5,
												mb: 1,
											}}>
											{historiaDescription.length}/550 caracteres
										</Typography>
										<div>
											<Button
												variant="contained"
												color="primary"
												onClick={saveHistoriaDescription}
												disabled={isLoading}>
												{isLoading ? <CircularProgress size={20} /> : "Guardar"}
											</Button>
											<Button
												variant="outlined"
												onClick={cancelHistoriaDescriptionEdit}
												disabled={isLoading}
												style={{ marginLeft: 8, backgroundColor: "#fff" }}>
												Cancelar
											</Button>
										</div>
									</div>
								) : (
									<p
										className="historia-description"
										style={{ cursor: "pointer" }}
										onClick={activateHistoriaDescriptionEdit}>
										{historiaDescription}
									</p>
								)}
							</>
						)}
					</div>

					{/* Mobile-only title container - will show only on mobile */}
					{!isDataLoading && (
						<div className="mobile-title-container" style={{ zIndex: 1 }}>
							{editingHistoriaTitle ? (
								<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
									<p style={{ fontSize: "14px", color: "#ccc", marginBottom: "4px" }}>
										Coloca entre * para poner texto en azul Ej: *Historia*
									</p>
									<TextField
										multiline
										minRows={3}
										variant="outlined"
										size="small"
										value={historiaTitle}
										onChange={handleHistoriaTitleChange}
										sx={{
											"& .MuiInputBase-input": {
												textAlign: "left",
												color: "#fff",
												fontSize: "30px",
												fontWeight: 800,
												lineHeight: "1.5",
											},
										}}
									/>
									<Typography
										variant="caption"
										sx={{
											display: "block",
											textAlign: "right",
											color:
												historiaTitle.length >= 60
													? historiaTitle.length >= 70
														? "error.main"
														: "warning.main"
													: "text.secondary",
											mt: 0.5,
											mb: 1,
										}}>
										{historiaTitle.length}/70 caracteres
									</Typography>
									<div>
										<Button
											variant="contained"
											color="primary"
											onClick={saveHistoriaTitle}
											disabled={isLoading}>
											{isLoading ? <CircularProgress size={20} /> : "Guardar"}
										</Button>
										<Button
											variant="outlined"
											onClick={cancelHistoriaTitleEdit}
											disabled={isLoading}
											sx={{ backgroundColor: "#fff", marginLeft: 2 }}>
											Cancelar
										</Button>
									</div>
								</div>
							) : (
								<h1
									className="historia-title"
									style={{ cursor: "pointer" }}
									onClick={activateHistoriaTitleEdit}>
									{parseTextWithAsterisks(historiaTitle)}
								</h1>
							)}
						</div>
					)}

					{/* Image container */}
					<div className="image-container-trap-right" style={{ zIndex: 1 }}>
						<div
							className="trapezoid-image-right"
							style={{ position: "relative", cursor: "pointer" }}
							onClick={() => handleOpenModal("historia")}>
							<img
								src={returnFullURL(companyDetails?.view3?.img_url, 'picture')}
								alt="Jhimbo store front"
								className="store-image"
							/>
							<div className="overlay">Cambiar Foto</div>
						</div>
					</div>

					{/* Mobile-only description container - will show only on mobile */}
					{!isDataLoading && (
						<div className="mobile-description-container" style={{ zIndex: 1 }}>
							{editingHistoriaDescription ? (
								<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
									<TextField
										variant="outlined"
										multiline
										minRows={4}
										value={historiaDescription}
										onChange={handleHistoriaDescriptionChange}
										sx={{
											"width": "100%",
											"& textarea": { textAlign: "left", color: "#fff" },
										}}
									/>
									<Typography
										variant="caption"
										sx={{
											display: "block",
											textAlign: "right",
											color:
												historiaDescription.length >= 500
													? historiaDescription.length >= 550
														? "error.main"
														: "warning.main"
													: "text.secondary",
											mt: 0.5,
											mb: 1,
										}}>
										{historiaDescription.length}/550 caracteres
									</Typography>
									<div>
										<Button
											variant="contained"
											color="primary"
											onClick={saveHistoriaDescription}
											disabled={isLoading}>
											{isLoading ? <CircularProgress size={20} /> : "Guardar"}
										</Button>
										<Button
											variant="outlined"
											onClick={cancelHistoriaDescriptionEdit}
											disabled={isLoading}
											style={{ marginLeft: 8, backgroundColor: "#fff" }}>
											Cancelar
										</Button>
									</div>
								</div>
							) : (
								<p
									className="historia-description"
									style={{ cursor: "pointer" }}
									onClick={activateHistoriaDescriptionEdit}>
									{historiaDescription}
								</p>
							)}
						</div>
					)}
				</div>
			</div>

			{/* SEGUNDO BLOQUE: "Nuestra Actualidad" */}
			<div className="actualidad-section">
				<div className="dots-1"></div>
				<div className="doughnut-1"></div>
				<div className="doughnut-2"></div>
				<div className="doughnut-3"></div>
				<div className="doughnut-4"></div>
				<div className="doughnut-5"></div>

				<div className="actualidad-content">
					<div style={{ backgroundColor: 'rgba(0,0,0,0.3)', zIndex: 0, width: '100%', height: '100%', position: 'absolute', top: '0px', left: '0px' }}></div>
					{/* Original text content - will be hidden on mobile */}
					<div className="text-content" style={{ zIndex: 1 }}>
						{isDataLoading ? (
							<>
								<Skeleton variant="text" width="70%" height={60} />
								<Skeleton variant="text" width="100%" height={25} />
								<Skeleton variant="text" width="95%" height={25} />
								<Skeleton variant="text" width="90%" height={25} />
							</>
						) : (
							<>
								{/* Título de Actualidad */}
								{editingActualidadTitle ? (
									<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
										<p style={{ fontSize: "14px", color: "#fff", marginBottom: "4px" }}>
											Coloca entre * para poner texto en azul Ej: *Actualidad*
										</p>
										<TextField
											multiline
											minRows={1}
											variant="outlined"
											size="small"
											value={actualidadTitle}
											onChange={handleActualidadTitleChange}
											sx={{
												"& .MuiInputBase-input": {
													textAlign: "left",
													color: "#fff",
													fontSize: "30px",
													fontWeight: 800,
												},
											}}
										/>
										<Typography
											variant="caption"
											sx={{
												display: "block",
												textAlign: "right",
												color:
													actualidadTitle.length >= 60
														? actualidadTitle.length >= 70
															? "error.main"
															: "warning.main"
														: "text.secondary",
												mt: 0.5,
												mb: 1,
											}}>
											{actualidadTitle.length}/70 caracteres
										</Typography>
										<div>
											<Button
												variant="contained"
												color="primary"
												onClick={saveActualidadTitle}
												disabled={isLoading}>
												{isLoading ? <CircularProgress size={20} /> : "Guardar"}
											</Button>
											<Button
												variant="outlined"
												onClick={cancelActualidadTitleEdit}
												disabled={isLoading}
												style={{ marginLeft: 8, backgroundColor: "#fff" }}>
												Cancelar
											</Button>
										</div>
									</div>
								) : (
									<h2
										className="actualidad-title"
										style={{ cursor: "pointer" }}
										onClick={activateActualidadTitleEdit}>
										{parseTextWithAsterisks(actualidadTitle)}
									</h2>
								)}

								{/* Descripción de Actualidad */}
								{editingActualidadDescription ? (
									<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
										<TextField
											variant="outlined"
											multiline
											minRows={4}
											value={actualidadDescription}
											onChange={handleActualidadDescriptionChange}
											sx={{
												"width": "100%",
												"& textarea": { textAlign: "left", color: "#fff" },
											}}
										/>
										<Typography
											variant="caption"
											sx={{
												display: "block",
												textAlign: "right",
												color:
													actualidadDescription.length >= 500
														? actualidadDescription.length >= 550
															? "error.main"
															: "warning.main"
														: "text.secondary",
												mt: 0.5,
												mb: 1,
											}}>
											{actualidadDescription.length}/550 caracteres
										</Typography>
										<div>
											<Button
												variant="contained"
												color="primary"
												onClick={saveActualidadDescription}
												disabled={isLoading}>
												{isLoading ? <CircularProgress size={20} /> : "Guardar"}
											</Button>
											<Button
												variant="outlined"
												onClick={cancelActualidadDescriptionEdit}
												disabled={isLoading}
												style={{ marginLeft: 8, backgroundColor: "#fff" }}>
												Cancelar
											</Button>
										</div>
									</div>
								) : (
									<p
										className="description"
										style={{ cursor: "pointer" }}
										onClick={activateActualidadDescriptionEdit}>
										{actualidadDescription}
									</p>
								)}
							</>
						)}
					</div>

					{/* Mobile-only title container - will show only on mobile */}
					{!isDataLoading && (
						<div className="mobile-title-container" style={{ zIndex: 1 }}>
							{editingActualidadTitle ? (
								<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
									<p style={{ fontSize: "14px", color: "#fff", marginBottom: "4px" }}>
										Coloca entre * para poner texto en azul Ej: *Actualidad*
									</p>
									<TextField
										multiline
										minRows={1}
										variant="outlined"
										size="small"
										value={actualidadTitle}
										onChange={handleActualidadTitleChange}
										sx={{
											"& .MuiInputBase-input": {
												textAlign: "left",
												color: "#fff",
												fontSize: "30px",
												fontWeight: 800,
											},
										}}
									/>
									<Typography
										variant="caption"
										sx={{
											display: "block",
											textAlign: "right",
											color:
												actualidadTitle.length >= 60
													? actualidadTitle.length >= 70
														? "error.main"
														: "warning.main"
													: "text.secondary",
											mt: 0.5,
											mb: 1,
										}}>
										{actualidadTitle.length}/70 caracteres
									</Typography>
									<div>
										<Button
											variant="contained"
											color="primary"
											onClick={saveActualidadTitle}
											disabled={isLoading}>
											{isLoading ? <CircularProgress size={20} /> : "Guardar"}
										</Button>
										<Button
											variant="outlined"
											onClick={cancelActualidadTitleEdit}
											disabled={isLoading}
											style={{ marginLeft: 8, backgroundColor: "#fff" }}>
											Cancelar
										</Button>
									</div>
								</div>
							) : (
								<h2
									className="actualidad-title"
									style={{ cursor: "pointer" }}
									onClick={activateActualidadTitleEdit}>
									{parseTextWithAsterisks(actualidadTitle)}
								</h2>
							)}
						</div>
					)}

					{/* Image Container */}
					<div className="image-container-trap" style={{ zIndex: 1 }}>
						<div
							className="trapezoid-image"
							style={{ position: "relative", cursor: "pointer" }}
							onClick={() => handleOpenModal("actualidad")}>
							<img
								src={returnFullURL(companyDetails?.view4?.img_url, 'picture')}
								alt="Jhimbo store front"
								className="store-image"
							/>
							<div className="overlay">Cambiar Foto</div>
						</div>
					</div>

					{/* Mobile-only description container - will show only on mobile */}
					{!isDataLoading && (
						<div className="mobile-description-container" style={{ zIndex: 1 }}>
							{editingActualidadDescription ? (
								<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
									<TextField
										variant="outlined"
										multiline
										minRows={4}
										value={actualidadDescription}
										onChange={handleActualidadDescriptionChange}
										sx={{
											"width": "100%",
											"& textarea": { textAlign: "left", color: "#fff" },
										}}
									/>
									<Typography
										variant="caption"
										sx={{
											display: "block",
											textAlign: "right",
											color:
												actualidadDescription.length >= 500
													? actualidadDescription.length >= 550
														? "error.main"
														: "warning.main"
													: "text.secondary",
											mt: 0.5,
											mb: 1,
										}}>
										{actualidadDescription.length}/550 caracteres
									</Typography>
									<div>
										<Button
											variant="contained"
											color="primary"
											onClick={saveActualidadDescription}
											disabled={isLoading}>
											{isLoading ? <CircularProgress size={20} /> : "Guardar"}
										</Button>
										<Button
											variant="outlined"
											onClick={cancelActualidadDescriptionEdit}
											disabled={isLoading}
											style={{ marginLeft: 8, backgroundColor: "#fff" }}>
											Cancelar
										</Button>
									</div>
								</div>
							) : (
								<p
									className="description"
									style={{ cursor: "pointer" }}
									onClick={activateActualidadDescriptionEdit}>
									{actualidadDescription}
								</p>
							)}
						</div>
					)}
				</div>
			</div>

			{/* Modal para cambiar imagen */}
			<Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
				<DialogTitle>
					Cambiar Imagen
					<IconButton
						aria-label="close"
						onClick={handleCloseModal}
						sx={{ position: "absolute", right: 8, top: 8 }}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>

				<DialogContent>
					<div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
						{!previewImg && (
							<Button variant="contained" component="label">
								Subir Imagen
								<input type="file" hidden accept="image/*" onChange={handleImageChange} />
							</Button>
						)}

						{previewImg && (
							<div
								style={{
									position: "relative",
									marginTop: "1rem",
									display: "flex",
									justifyContent: "center",
								}}>
								<img
									src={previewImg}
									alt="preview"
									style={{
										width: "300px",
										height: "auto",
										borderRadius: "8px",
										objectFit: "contain",
									}}
								/>
								<IconButton
									onClick={handleRemovePreview}
									disabled={isLoading}
									style={{
										position: "absolute",
										top: "-10px",
										right: "100px",
										backgroundColor: "red",
									}}>
									<CloseIcon sx={{ color: "#fff" }} />
								</IconButton>
							</div>
						)}
					</div>
				</DialogContent>

				<DialogActions>
					<Button onClick={handleCloseModal} disabled={isLoading}>
						Cancelar
					</Button>
					<Button
						onClick={handleAccept}
						disabled={!previewImg || isLoading}
						variant="contained"
						startIcon={isLoading ? <CircularProgress size={20} /> : null}>
						{isLoading ? "Subiendo..." : "Aceptar"}
					</Button>
				</DialogActions>
			</Dialog>

			<style>{`
  .overlay {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.5);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 0;
    transition: opacity 0.3s ease;
    font-size: 1.2rem;
    font-weight: bold;
    z-index: 1;
  }

  .trapezoid-image {
    position: relative;
    overflow: hidden;
  }

  .trapezoid-image img.store-image {
    clip-path: polygon(
      0% 0%,
      85% 0%,
      100% 100%,
      0% 100%
    );
  }

  .trapezoid-image-right {
    position: relative;
    overflow: hidden;
  }

  .trapezoid-image-right img.store-image {
    clip-path: polygon(
      15% 0%,
      100% 0%,
      100% 100%,
      -1% 100%
    );
  }

  .trapezoid-image:hover .overlay,
  .trapezoid-image-right:hover .overlay {
    opacity: 1;
  }
`}</style>
		</div>
	);
};
